import { Order } from "./order";

type TposBasketContextType = {
  selectedBasketItem?: number;
  selectedOrder?: Order;
  setOrder?: (order: Order) => void;
  clearOrder?: () => void;
};

export type { TposBasketContextType };
